import React from 'react';
import { Lock } from 'lucide-react';

export function PayrollPeriodClosedBadge({ compact = false }: { compact?: boolean }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-app-surface-muted font-medium text-app-text-muted ${
        compact ? 'px-1.5 py-0.5 text-xs' : 'px-2 py-0.5 text-xs'
      }`}
    >
      <Lock className={compact ? 'h-2.5 w-2.5' : 'h-3 w-3'} aria-hidden />
      Abgeschlossen
    </span>
  );
}

export function PayrollPeriodClosedBanner({
  isApprover,
  className = '',
}: {
  isApprover: boolean;
  className?: string;
}) {
  return (
    <div
      className={`rounded-md border border-app-border bg-app-surface-muted px-3 py-2 text-xs text-app-text-muted ${className}`}
    >
      <p className="font-medium text-app-text">Abrechnungsmonat abgeschlossen</p>
      <p className="mt-0.5 text-app-text-muted">
        {isApprover
          ? 'Sie können Zeiteinträge in diesem Monat direkt bearbeiten.'
          : 'Änderungen werden als Antrag eingereicht und müssen freigegeben werden.'}
      </p>
    </div>
  );
}
